import { gql } from '@apollo/client';

export const UserFragment = gql`
  fragment User on User {
    _id
    email
    academy
    name
    profilePicture
    role
    mustChangePassword
    changePasswordToken
  }
`;
